var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += 'You should probably inject a proper booking form...';

}
return __p
};

/*
original source:

You should probably inject a proper booking form...

*/
